export const BOARD_SIZES = ['xs', 's', 'm', 'l', 'xl', '2xl', '3xl']

export const COLUMNS_BY_SIZE = {
  xs: 5,
  s: 6,
  m: 7,
  l: 8,
  xl: 9,
  '2xl': 10,
  '3xl': 11
}

export const PAIRS_BY_SIZE = {
  xs: 15,
  s: 18,
  m: 21,
  l: 24,
  xl: 27,
  '2xl': 30,
  '3xl': 33
}

export const CARDS_PER_SIZE = {
  xs: 30,
  s: 36,
  m: 42,
  l: 48,
  xl: 54,
  '2xl': 60,
  '3xl': 66
}

export const SPECIAL_CARDS = []

export const PAIR_POINTS = 10
export const SPECIAL_PAIR_POINTS = 10

export const FLIP_BACK_DELAY = 1000
